<template>
    <div class="tw-text-center tw-mt-4">
        <label
            class="tw-inline-block tw-relative tw-group"
            for="profile-picture-upload"
            data-test-id="profile-picture-upload"
        >
            <l-profile-picture :user="currentUser" size="xl" />

            <div
                class="tw-absolute tw-cursor-pointer tw-rounded-full tw-h-full tw-w-full tw-top-0 tw-left-0 tw-transition-opacity tw-duration-200 tw-bg-gray-900 tw-flex group-hover:tw-opacity-75 tw-items-center tw-justify-center tw-text-gray-50"
                :class="{ 'tw-opacity-75': isLoading, 'tw-opacity-0': !isLoading }"
            >
                <template v-if="isLoading">{{ $t("profile.edit.uploading") }}...</template
                ><template v-else>{{ $t("profile.edit.btnChangePicture") }}</template>
            </div>

            <input
                id="profile-picture-upload"
                type="file"
                name="file"
                accept="image/*"
                class="hidden"
                :disabled="hasAllFieldsDisabled"
                :readonly="hasAllFieldsDisabled"
                @change="onUpload($event.target)"
            />
        </label>

        <l-text-alert
            v-if="hasError"
            class="tw-mt-4 tw-leading-none tw-text-sm"
            type="danger"
            data-test-id="error"
            :text="errorMessage"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LProfilePicture from "@/components/LProfilePicture";
import LTextAlert from "@/components/LTextAlert";

import resizeAndCropImageFile from "@/utils/resize-and-crop-image-file";

export default {
    components: { LProfilePicture, LTextAlert },
    data() {
        return {
            hasError: false,
            errorMessage: "",
            isLoading: false,
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            rights: "users/current/rights",
        }),
        hasAllFieldsDisabled() {
            return this.isLoading;
        },
    },
    methods: {
        async onUpload(target) {
            const { files } = target;
            if (!files) return;

            let file = files[0];
            if (!file) return;

            try {
                file = await resizeAndCropImageFile(file);
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.message;
                return;
            }

            this.isLoading = true;
            this.hasError = false;

            try {
                await this.$store.dispatch("users/current/updateProfilePicture", {
                    payload: { file },
                });
            } catch (err) {
                this.hasError = true;
                this.errorMessage = err.response?.data?.message ?? err.message;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
